import { httpLog as log } from "@utils/log";

export const successLog = (requestConfig, data) => {
    try {
        log('\n', `${requestConfig.url} --- 接口信息：\n`,
            '入参：', requestConfig.data, '\n',
            "耗时：", +new Date() - requestConfig.requestConfig._requestStart, '\n', '\n',
            "header：", requestConfig.headers, '\n',
            "返回：", data, '\n', '\n',
        );
    } catch (e) {

    }
}
